import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HeaderBar from '../../components/HeaderBar';
import TablePage from './TablePage';
import HistogramBrokenLine from './HistogramBrokenLine';
import moment from 'moment';

const Icons = [{ icon: '\ue659', order: 0 }, { icon: '\ue652', order: 1 }];

class AnnualPaymentCollectionAnalysis extends Component {
    static contextTypes = {
        businessList: PropTypes.array,
        clientHeight: PropTypes.number
    }

    constructor(props) {
        super(props);
        this.icons = Icons;
        this.state = {
            current: 0,
            searchParams: {
                year:moment().format('YYYY')
            },
            searchInfo:{

            }
        };
    }

    handleIconChange = (current) => {
        this.setState({ current });
    }

    handleChange = (searchParams) => {
        this.setState({ searchParams: {...searchParams} });
    }

    searchChange=(searchInfo)=>{
        this.setState({ searchInfo: {...searchInfo} });
    }

    render() {
        const { businessList, clientHeight } = this.context;
        const { current, searchParams,searchInfo } = this.state;
        return (
            <div className="pane-item">
                <HeaderBar
                    title="年度回款分析"
                    onChange={this.handleIconChange}
                    current={current}
                    icons={this.icons}
                />
                {
                    current === 0 &&
                    <TablePage
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                        businessList={businessList}
                        onChange={this.handleChange}
                        searchInfo={searchInfo}
                        searchChange={this.searchChange}
                    />
                }
                {
                    current === 1 &&
                    <HistogramBrokenLine
                        searchParams={searchParams}
                        clientHeight={clientHeight}
                        searchInfo={searchInfo}
                        searchChange={this.searchChange}
                    />
                }
            </div>
        );
    }
}

export default AnnualPaymentCollectionAnalysis;


// WEBPACK FOOTER //
// ./src/components/RequestDataAnalysis/RequestAndReturnedSheet/AnnualPaymentCollectionAnalysis/index.js